"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../css/style.css");
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var About_1 = __importDefault(require("./components/sections/About"));
var Contact_1 = __importDefault(require("./components/sections/Contact"));
var Footer_1 = __importDefault(require("./components/sections/Footer"));
var Header_1 = __importDefault(require("./components/sections/Header"));
var Robots_1 = __importDefault(require("./components/sections/Robots"));
var Title_1 = __importDefault(require("./components/sections/Title"));
function App() {
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(Header_1.default, null),
        react_1.default.createElement(Title_1.default, null),
        react_1.default.createElement(About_1.default, null),
        react_1.default.createElement(Robots_1.default, null),
        react_1.default.createElement(Contact_1.default, null),
        react_1.default.createElement(Footer_1.default, null)));
}
var root = (0, client_1.createRoot)(document.getElementById("main"));
root.render(react_1.default.createElement(App, null));
function hello() {
    return "Hello!";
}
console.log(hello());
